import { DateTime } from 'luxon';
import { CustomerCustomer } from '../customer/customer-customer';
import { PaymentStatus } from '../../quipli-service/payment/payment';
import { InvoiceParsers } from '../../quipli-service/invoice/invoice-parsers';
import { CustomerInvoice, CustomerPayment } from './customer-invoice';
import { InvoiceStatus } from '../../quipli-service/invoice/invoice';
import { PaymentParsers } from '../../quipli-service/payment/payment-parsers';

export namespace CustomerInvoiceParsers {
  export type CustomerInvoiceJson = {
    id: string;
    customer: CustomerCustomer;
    locationId: number;
    invoiceNumber?: string;
    type: 'Order';
    typeId: number;
    taxRate: number;
    lineItems: InvoiceParsers.LineItemJson[];
    payments: CustomerPaymentJson[];
    subtotal: number;
    tax: number;
    total: number;
    balance: number;
    date?: string;
    dueDate?: string;
    createdAt: string;
    updatedAt: string;
    status: InvoiceStatus;
  };

  export type InvoicePaymentJson = {
    id: string;
    invoiceId: string;
    paymentId: string;
    amount: number;
    updatedAt?: string;
    createdAt?: string;
    deletedAt?: string;
  };

  export type CustomerPaymentJson = {
    id: string;
    invoiceId: string;
    method: string;
    methodDetail?: string;
    status: PaymentStatus;
    gatewayStatus?: string;
    amount: number;
    refundedPaymentId?: string;
    paidAt: string;
    clientSecret?: string;
    paymentMethod?: string;
    userId: number;
    creditPaymentId?: string;
    creditAmount?: number;
    invoicePayments: InvoicePaymentJson[];
  };

  export function toCustomerInvoice(input: CustomerInvoiceJson): CustomerInvoice {
    return {
      id: input.id,
      customer: input.customer,
      locationId: input.locationId,
      invoiceNumber: input.invoiceNumber,
      type: input.type,
      typeId: input.typeId,
      taxRate: input.taxRate,
      lineItems: input.lineItems.map(InvoiceParsers.toLineItem),
      payments: input.payments.map(toCustomerPayment),
      subtotal: input.subtotal,
      tax: input.tax,
      total: input.total,
      balance: input.balance,
      date: input.date ? DateTime.fromISO(input.date, { setZone: true }) : undefined,
      dueDate: input.dueDate ? DateTime.fromISO(input.dueDate, { setZone: true }) : undefined,
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
      updatedAt: DateTime.fromISO(input.updatedAt, { setZone: true }),
      status: input.status,
    };
  }

  export function toCustomerPayment(input: CustomerPaymentJson): CustomerPayment {
    return {
      id: input.id,
      invoiceId: input.invoiceId,
      method: input.method,
      methodDetail: input.methodDetail,
      status: input.status,
      gatewayStatus: input.gatewayStatus,
      amount: input.amount,
      refundedPaymentId: input.refundedPaymentId,
      paidAt: DateTime.fromISO(input.paidAt, { setZone: true }),
      clientSecret: input.clientSecret,
      paymentMethod: input.paymentMethod,
      userId: input.userId,
      creditPaymentId: input.creditPaymentId,
      invoicePayments: input.invoicePayments.map(PaymentParsers.toInvoicePayment),
    };
  }
}
